export const EMAIL = "email";
export const PASSWORD = "password";
export const MAGIC_CODE = "magic_code";
export const ERROR_DONT_SHOW = "@dontshow";

/**
 * Inline script for `_document`: stops every form without an `action` from
 * submitting natively. All our forms are handled by React, but a native submit
 * still gets through when React is not (yet) handling the form, and a bare
 * <form> then sends a GET to the current URL: email and password ended up in
 * the query string, and from there in Vercel logs and analytics (WHO-6151).
 * A form with an explicit `action` (the US waitlist) is meant to post
 * natively and is left alone. React's own `onSubmit` still runs.
 */
export const NATIVE_SUBMIT_GUARD = `document.addEventListener("submit",function(e){if(!e.target.hasAttribute("action"))e.preventDefault()},true);`;
